import * as etsyBulkNewListing from './bulkCreateCsv';
import * as etsyBulkCreateGdriveFile from './bulkCreateGdriveFile';
import * as etsyBulkCreateGdriveFolder from './bulkCreateGdriveFolder';
import * as etsyBulkUpdateCsv from './bulkUpdateCsv';
import * as etsyNewSingleListing from './newSingleListing';
import * as etsyUpdateListingSeo from './updateListingSeo';

export const etsyFeatures = {
  ...etsyBulkCreateGdriveFile,
  ...etsyBulkCreateGdriveFolder,
  ...etsyBulkNewListing,
  ...etsyBulkUpdateCsv,
  ...etsyNewSingleListing,
  ...etsyUpdateListingSeo,
};
